import React, { Fragment, useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import Select from 'react-select';
import { graySelectStyles } from '../../common/selectStyles';
import { getStudents } from '../../api/services/studentService';
import { addExistingStudentToCaseload } from '../../api/services/caseloadService';
import Student from '../../api/models/student';
import Layout from '../../components/layout';
import { FieldInput } from '../../components/fieldInput';
import SubmitButton from '../../components/submitButton';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DataTable from '../../components/dataTable';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ResponseStatus } from '../../components/notifications';
import Modal from '../../components/modal';
import { getTherapistRoles } from '../../api/services/therapistRolesService';
import { getStudentStatuses } from '../../api/services/studentStatusService';
import { getDivisionPlacements } from '../../api/services/placementService';
import { getDivisionEsys } from '../../api/services/esyService';
import { studentStatuses } from '../../common/constants';
import Therapist from '../../api/models/therapist';

type Search = {
  disciplineId: number;
  firstName: string;
  lastName: string;
  dob: Date | undefined;
};

type ViewState = {
  disciplineId: number;
  therapists: Therapist[];
  studentFirstName: string;
  studentLastName: string;
};

const fetchStudents = async (args: Search[]) => {
  let dob = args[0].dob === undefined || null || args[0].dob?.toString() === 'undefined' ? '' : moment(args[0].dob).format('MM/DD/YYYY');

  return await getStudents(
    args[0].disciplineId,
    args[0].firstName,
    args[0].lastName,
    dob.toString() === 'Invalid date' || dob === null || dob === undefined || dob === '' ? '' : moment(args[0].dob).format('MM/DD/YYYY')
  );
};

const fetchTherapistRoles = async () => {
  return await getTherapistRoles();
};

const fetchStatuses = async () => {
  return await getStudentStatuses();
};

const fetchPlacement = async (args: any[]) => {
  return await getDivisionPlacements(args[0]);
};

const fetchEsys = async (args: any[]) => {
  return await getDivisionEsys(args[0]);
};
const SearchStudents = () => {
  const [myself, setMyself] = useState<Therapist>();
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: (s: any) => s.lastName + ', ' + s.firstName,
      },
      {
        Header: 'District',
        accessor: (s: any) =>
          !s.studentSchools || s.studentSchools.length === 0
            ? ''
            : s.studentSchools[0].school.district.name,
        width: 250,
      },
      {
        Header: 'School',
        accessor: (s: any) =>
          !s.studentSchools || s.studentSchools.length === 0 ? '' : s.studentSchools[0].school.name,
      },
      {
        Header: 'DOB',
        accessor: (s: any) => moment(s.dob).format('MM/DD/YYYY'),
      },
      {
        Header: 'Grade',
        accessor: (s: any) => s.grade?.name,
      },
      {
        Header: 'Status',
        accessor: (s: any) => {
          var today = new Date();

          if (s !== undefined && s.studentDisciplines !== undefined && Array.isArray(s.studentDisciplines) && s.studentDisciplines.length > 0) {
            for (var sD of s.studentDisciplines) {
              for (var i of sD.caseloads) {
                if (i.therapist !== null && i.therapist !== undefined && i.therapist.therapistId === myself?.therapistId) {
                  var endDate = i.endDate != null ? new Date(Date.parse(i.endDate.toString())) : null;
                  var deletedOn = i.deletedOn != null ? new Date(Date.parse(i.deletedOn.toString())) : null;
                  if (((endDate == null) || (endDate > today)) && ((deletedOn == null) || (deletedOn > today))) {
                    return sD.studentStatus.name;
                  }
                }
              }
            }
          }
          return '';
          /*return s.studentDisciplines.length === 0
            ? ''
            : s.studentDisciplines[0].studentStatus.name,*/
        }
      },
      {
        accessor: 'studentId',
        className: 'hidden',
      },
    ],
    [myself]
  );
  const { state } = useLocation<ViewState>();
  const [students, setStudents] = useState<Student[]>([]);
  const history = useHistory();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState<Date>();
  const [completeSearch, setSearch] = useState(false);
  const [openStudent, setOpenStudent] = useState(false);
  const [selectStudent, setSelectStudent] = useState<Student>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [requireDob, setRequireDob] = useState(true);
  const [showDob, setShowDob] = useState(true);
  const [searchMatched, setSearchMatched] = useState(false);
  const [caseloadStartDate, setCaseloadStartDate] = useState<Date>();
  const [caseloadEndDate, setCaseloadEndDate] = useState<Date>();
  const [therapistType, setTherapistType] = useState<number | undefined>(0);
  const [studentStatus, setStudentStatus] = useState<number>(0);
  const [placement, setPlacement] = useState<number>(0);
  const [esy, setEsy] = useState<number>(0);
  const [onCaseload, setOnCaseload] = useState<boolean>(false);
  const [onlyOnCaseload, setOnlyOnCaseload] = useState<boolean>(false);


  const addStudent = async () => {
    return await addExistingStudentToCaseload({
      disciplineId: state.disciplineId,
      studentId: Number(selectStudent?.studentId),
      isApproved: true,
      placement: placement,
      esy: esy,
      startDate: caseloadStartDate?.toLocaleDateString(),
      endDate: caseloadEndDate?.toLocaleDateString(),
      studentStatusId: studentStatus,
      TherapistRoleId: therapistType,
    });
  };
  const therapistRolesData = useAsync({
    promiseFn: fetchTherapistRoles,
  });

  const studentStatusData = useAsync({
    promiseFn: fetchStatuses,
  });

  const esyData = useAsync({ deferFn: fetchEsys });
  const placementData = useAsync({ deferFn: fetchPlacement });

  const search = useAsync({
    deferFn: () => fetchStudents([{ disciplineId: state.disciplineId, firstName, lastName, dob }]),
    onResolve: (r) => {

      var match = r.data.students.findIndex(i => i.firstName.toLowerCase() === firstName.toLowerCase() && i.lastName.toLowerCase() === lastName.toLowerCase());
      if (match !== -1) {
        //If there's an exact name match, let's make sure it always shows first in the result set
        var data = r.data.students.filter((item, idx) => idx !== match);
        data.unshift(r.data.students[match]);
        setStudents(data);
      } else {
        setStudents(r.data.students);
      }

      setSearchMatched(match !== -1);
      setSearch(true);
      setRequireDob(true);
    },
  });

  const addToCaseload = useAsync({
    deferFn: addStudent,
    onResolve: (response) => {
      if (studentStatus === studentStatuses.OnCaseload.studentStatusId) {
        history.push(`/caseload/${response.data.caseload.caseloadId}`,{ idSpecific: 'caseload'});
      } else {
        setShowConfirmation(true);
      }
    }
  });

  const handleSearch = () => {
    setSearch(false);
    setRequireDob(true);
    search.run();
  };

  const handleRowClick = (e: number) => {
    setOpenStudent(true);
    var student = students.find((s) => s.studentId === e);
    if (student !== undefined) {
      var divisionId = student.studentSchools?.[0]?.school?.district?.division?.divisionId ?? 0;
      esyData.run(divisionId);
      placementData.run(divisionId);
      setSelectStudent(student);
    }
  };

  const handleRefresh = () => {
    setShowConfirmation(false);
    setStudents([]);
    setFirstName('');
    setLastName('');
    setSearch(false);
    setRequireDob(true);
    setShowDob(true);
    setDob(undefined);
    setCaseloadStartDate(undefined);
    setCaseloadEndDate(undefined);
    setTherapistType(0);
    setStudentStatus(0);
  };

  useEffect(() => {
    var today = new Date();
    setOnCaseload(false);
    setOnlyOnCaseload(false);
    //debugger;
    if (selectStudent !== undefined && selectStudent.studentDisciplines !== undefined && Array.isArray(selectStudent.studentDisciplines) && selectStudent.studentDisciplines.length > 0) {

      selectStudent?.studentDisciplines.forEach((sd) => {
        if (sd.studentStatus != null && sd.studentStatus != undefined && sd.studentStatus.name == "On Caseload") {
          setOnlyOnCaseload(true);
        }
        sd?.caseloads?.forEach((i) => {
          if (i.therapist !== null && i.therapist !== undefined && i.therapist.therapistId === myself?.therapistId) {
            var endDate = i.endDate != null ? new Date(Date.parse(i.endDate.toString())) : null;
            var deletedOn = i.deletedOn != null ? new Date(Date.parse(i.deletedOn.toString())) : null;
            if (((endDate == null) || (endDate > today)) && ((deletedOn == null) || (deletedOn > today))) {
              setOnCaseload(true);
            }
          }
        });
      });

    }
  }, [selectStudent]);
  useEffect(() => {
    if (state && state.therapists) {
      for (var t of state.therapists) {
        if (t.discipline != null && t.discipline != undefined && t.discipline.disciplineId == state.disciplineId) {
          setMyself(t);
          break;
        }
      }
    }
  }, []);

  return (
    <Fragment>
      <Modal
        saveText={onCaseload ? 'Already On Caseload' : 'Add to Caseload'}
        allowSave={
          !onCaseload &&
          caseloadStartDate !== undefined &&
          caseloadStartDate !== null &&
          therapistType !== undefined &&
          therapistType !== 0 &&
          studentStatus !== undefined &&
          studentStatus !== 0 &&
          placement !== undefined &&
          placement !== 0 &&
          esy !== undefined &&
          esy !== 0
        }
        open={openStudent}
        onCancel={() => setOpenStudent(false)}
        onSave={() => {
          addToCaseload.run();
          setOpenStudent(false);
        }}
      >
        <Fragment>
          <div className='grid grid-cols-6 gap-6 mb-6 '>
            <div className='col-span-6 sm:col-span-6 lg:col-span-5 disabled'>
              <FieldInput
                noshow={true}
                name='firstName'
                label='First Name'
                value={selectStudent !== undefined ? selectStudent.firstName : ''}
              />
            </div>
            <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
              <FieldInput
                noshow={true}
                name='mi'
                label='MI'
                value={selectStudent !== undefined ? selectStudent.mi : ''}
              />
            </div>
            <div className='col-span-6 sm:col-span-6 lg:col-span-5'>
              <FieldInput
                noshow={true}
                name='lastName'
                label='Last Name'
                value={selectStudent !== undefined ? selectStudent.lastName : ''}
              />
            </div>
            <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
              <FieldInput
                noshow={true}
                name='suffix'
                label='Suffix'
                value={selectStudent !== undefined ? selectStudent.suffix : ''}
              />
            </div>
            <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
              <FieldInput
                noshow={true}
                name='dateofbirth'
                label='Date Of Birth'
                value={
                  selectStudent !== undefined
                    ? moment(selectStudent.dob.toString()).format('MM/DD/YYYY')
                    : ''
                }
              />
            </div>

            <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
              <FieldInput
                noshow={true}
                name='grade'
                label='Grade'
                value={
                  selectStudent !== undefined ? selectStudent.grade?.name : ''
                }
              />
            </div>
            <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
              <FieldInput
                noshow={true}
                name='gender'
                label='Gender'
                value={selectStudent?.gender?.name ?? ""}
              />
            </div>
            <div className='col-span-6 sm:col-span-6'>
              <FieldInput
                noshow={true}
                name='district'
                label='District'
                value={
                  selectStudent?.studentSchools?.[0]?.school?.district?.name ?? ""
                }
              />
            </div>
            <div className='col-span-6 sm:col-span-6'>
              <FieldInput
                noshow={true}
                name='school'
                label='School'
                value={
                  selectStudent?.studentSchools?.[0]?.school?.name ?? ""
                }
              />
            </div>
            {/* {onCaseload && (
              <Fragment>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <FieldInput
                    name='caseloadStartDate'
                    label='Caseload Start Date'
                    value={
                      selectStudent !== undefined ? selectStudent.studentDisciplines[0]. : ''
                    }
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <FieldInput
                    name='caseloadStartDate'
                    label='Caseload Start Date'
                    value={
                      selectStudent !== undefined ? selectStudent.studentDisciplines[0]. : ''
                    }
                  />
                </div>
              </Fragment>
            )} */}
            {!onCaseload && (
              <Fragment>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>
                    Placement <span className='pl-1 text-red-500'>*</span></label>
                  <Select
                    options={placementData.data?.data.placements.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.placementId, label: g.name })) || []}
                    value={(placementData.data?.data.placements.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.placementId, label: g.name })) || []).find((o) => o.value === placement) || null}
                    onChange={(selected) => setPlacement(Number(selected?.value))}
                    placeholder=' -- Select --'
                    styles={graySelectStyles}
                    isSearchable={false}
                    className='block mt-1'
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>
                    ESY Eligible <span className='pl-1 text-red-500'>*</span></label>
                  <Select
                    options={esyData.data?.data.esys.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.esyId, label: g.name })) || []}
                    value={(esyData.data?.data.esys.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.esyId, label: g.name })) || []).find((o) => o.value === esy) || null}
                    onChange={(selected) => setEsy(Number(selected?.value))}
                    placeholder=' -- Select --'
                    styles={graySelectStyles}
                    isSearchable={false}
                    className='block mt-1'
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>
                    Caseload Start Date
                    <span className='pl-1 text-red-500'>*</span>
                  </label>
                  <DatePicker
                    className='block mt-1 primary'
                    selected={caseloadStartDate}
                    onChange={(date: Date) => setCaseloadStartDate(date!)}
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>Caseload End Date</label>
                  <DatePicker
                    className='block mt-1 primary'
                    selected={caseloadEndDate}
                    onChange={(date: Date) => setCaseloadEndDate(date!)}
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>
                    Therapist Type<span className='pl-1 text-red-500'>*</span>
                  </label>
                  <Select
                    options={therapistRolesData.data?.data.therapistRoles.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.therapistRoleId, label: g.name })) || []}
                    value={(therapistRolesData.data?.data.therapistRoles.sort((a, b) => a.name.localeCompare(b.name)).map((g) => ({ value: g.therapistRoleId, label: g.name })) || []).find((o) => o.value === therapistType) || null}
                    onChange={(selected) => setTherapistType(Number(selected?.value))}
                    placeholder=' -- Choose Therapist Type --'
                    styles={graySelectStyles}
                    isSearchable={false}
                    className='block mt-1'
                  />
                </div>
                <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                  <label className='primary'>
                    Student Status<span className='pl-1 text-red-500'>*</span>
                  </label>
                  <Select
                    options={studentStatusData.data?.data.studentStatuses
                      .filter((ss) => onlyOnCaseload ? ss.name == "On Caseload" : true)
                      .sort((a, b) => a.name.localeCompare(b.name)).map((s) => ({ value: s.studentStatusId, label: s.name })) || []}
                    value={(studentStatusData.data?.data.studentStatuses
                      .filter((ss) => onlyOnCaseload ? ss.name == "On Caseload" : true)
                      .sort((a, b) => a.name.localeCompare(b.name)).map((s) => ({ value: s.studentStatusId, label: s.name })) || []).find((o) => o.value === studentStatus) || null}
                    onChange={(selected) => setStudentStatus(Number(selected?.value))}
                    placeholder=' -- Choose Status --'
                    styles={graySelectStyles}
                    isSearchable={false}
                    className='block mt-1'
                  />
                </div>

              </Fragment>
            )}
          </div>
        </Fragment>
      </Modal>
      <Layout>
        <Fragment>
          {!showConfirmation && (
            <Fragment>
              {search.error && <ResponseStatus state={search} />}
              {addToCaseload.error && <ResponseStatus state={addToCaseload} />}
              <div className='mb-6 overflow-hidden shadow sm:rounded-md'>
                <div className='px-4 py-5 bg-white sm:p-6'>
                  <div className='grid grid-cols-6 gap-6'>
                    <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
                      <FieldInput
                        name='firstName'
                        label='First Name'
                        minLength={1}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={firstName}
                      />
                    </div>

                    <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                      <FieldInput
                        name='lastName'
                        label='Last Name'
                        minLength={1}
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName}
                      />
                    </div>
                    {showDob && (<div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                      <label className='block mb-1 primary'>
                        Date Of Birth
                        {requireDob && (
                          <span className="pl-1 text-red-500">*<small className="pl-1 font-normal text-black"></small></span>
                        )}
                      </label>
                      <DatePicker
                        className='block primary'
                        selected={dob}
                        required={requireDob}
                        onChange={(date: Date) => date !== undefined ? setDob(date!) : setDob(undefined)}
                        maxDate={new Date()}
                      />
                    </div>)}
                  </div>
                </div>
                <div className='px-4 py-3 text-right bg-gray-50 sm:px-6'>
                  <SubmitButton
                    text='Search'
                    spinning={search.isPending}
                    onClick={handleSearch}
                    disabled={firstName.length === 0 || lastName.length === 0 || dob === undefined || dob === null}
                    className='mr-5 primary button float-left'
                  />
                  {completeSearch && (
                    <div className='float-left ml-5'>
                      <div>
                        <div>
                          {(
                            (
                              (
                                firstName !== null &&
                                lastName !== null &&
                                firstName.length > 0 &&
                                lastName.length > 0)
                                ?
                                <Link
                                  className='float-left btn'
                                  to={{
                                    pathname: '/caseload/new',
                                    state: {
                                      disciplineId: state.disciplineId,
                                      approved: !searchMatched,
                                      studentFirstName: firstName,
                                      studentLastName: lastName,
                                      dob: dob,
                                      searchMatched: searchMatched
                                    },
                                  }}
                                >Create Student
                                </Link>
                                :
                                <Link
                                  to="/"
                                  className='float-left cursor-not-allowed btn btn-disabled focus:outline-none disabled:opacity-75'
                                  onClick={(event) => event.preventDefault()}
                                >Create Student
                                </Link>

                            )
                          )}
                          <div className="float-left p-2 text-red-600 ">If you did not find your student in the list below, please select create student.</div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='clear-both'></div>
                </div>
              </div>

              {completeSearch && (
                <div>
                  {students.length === 0 && (<label>No students found.</label>)}
                </div>
              )}

              {students.length > 0 && (
                <DataTable
                  columns={columns}
                  data={students}
                  showPagination={true}
                  getRowProps={(row: any) => ({
                    onClick: () => handleRowClick(row.values.studentId),
                  })}
                />
              )}

            </Fragment>
          )}
          {showConfirmation && (
            <Fragment>
              <ResponseStatus state={addToCaseload} />
              <div className='px-4 py-3 bg-gray-100 sm:px-6 sm:flex sm:flex-row-reverse'>
                <SubmitButton
                  text='Add another Student'
                  onClick={handleRefresh}
                  className='inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white transition duration-150 ease-in-out border border-transparent rounded-md shadow-sm bg-ptsblue-normal hover:bg-ptsblue-dark focus:outline-none sm:ml-3 sm:w-auto sm:text-sm'
                />
                <SubmitButton
                  text='Go back to my caseload'
                  onClick={() => history.push(`/caseload/?discipline=${state.disciplineId}`)}
                  className='inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                />
              </div>
            </Fragment>
          )}
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default SearchStudents;

